<template>
    <el-card class="box-card" style="margin-bottom: 30px;" v-if="commitments">
        <div slot="header" class="clearfix">
            <h3 class="mb-0">Total Instalment</h3>
        </div>
        <div>
            <instalmentChart type="donut" :options="instalmentOptions" :series="instalmentSeries" :height="270"></instalmentChart>
        </div>
    </el-card>
</template>
<script>
    import { Card } from 'element-ui'
    import VueApexCharts from 'vue-apexcharts';

    export default {
        props: ['commitments'],
        name: 'total-instalment',
        components: {
            "instalmentChart": VueApexCharts,
            [Card.name]: Card,
        },
        data() {
            return {
                instalmentSeries: [],
                instalmentOptions: {
                    chart: {
                        type: 'donut',
                    },
                    legend: {
                        position: 'bottom',
                        
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: true,
                                    value: {
                                        show: true,
                                        fontSize: '17px',
                                        fontWeight: 600,
                                        color: undefined,
                                        offsetY: 0,
                                        formatter: function (val) {
                                            return val
                                        }
                                    },
                                    total: {
                                        label: 'TOTAL (RM)',
                                        showAlways: true,
                                        show: true,
                                        fontSize: '12px',
                                        formatter: function (w) {
                                            let total = w.globals.seriesTotals.reduce((a, b) => {
                                                return a + b
                                            }, 0).toFixed(2)     
                                            if(w.globals.labels.includes('No Installment')){
                                                total = 0
                                            }  
                                            return parseFloat(total).toLocaleString(undefined, {minimumFractionDigits: 2})                          
                                        }
                                    },
                                }
                            }
                        },
                    },
                    labels: [],
                    dataLabels: {
                        enabled: false,
                    },
                    tooltip: {
                        enabled: false,
                        y: {
                            formatter: function(val) {
                                return "RM" + val.toFixed(2);
                            }
                        }
                    },
                }
            }
        },
        created(){
            this.setChart()
        },
        methods: {
            setChart(){
                this.commitments.forEach(item => {
                    if(item.commitment_is_manual === 0){
                        item.commitment_sub_items.forEach(sub_item => {
                            let foundIndex = this.instalmentOptions.labels.indexOf(sub_item.commitment_loan_statue)
    
                            if (foundIndex !== -1) {
                                let installment = parseFloat(sub_item.commitment_new_installment);
                                this.instalmentSeries[foundIndex] += installment;
                            } else {
                                if(sub_item.commitment_new_installment !== "0.00"){
                                    let installment = parseFloat(sub_item.commitment_new_installment);
                                    this.instalmentSeries.push(installment);
                                    this.instalmentOptions.labels.push(sub_item.commitment_loan_statue);
                                }
                            }
                        });
                    }else{
                        let foundIndex = this.instalmentOptions.labels.indexOf(item.commitment_loan_statue)
    
                        if (foundIndex !== -1) {
                            let installment = parseFloat(item.commitment_new_installment);
                            this.instalmentSeries[foundIndex] += installment;
                        } else {
                            if(item.commitment_new_installment !== "0.00"){
                                let installment = parseFloat(item.commitment_new_installment);
                                this.instalmentSeries.push(installment);
                                this.instalmentOptions.labels.push(item.commitment_loan_statue);
                            }
                        }
                    }
                });

                this.instalmentOptions.labels = this.instalmentOptions.labels.map((item, index) => {
                    return item+'<br> <b><b>RM'+ parseFloat(this.instalmentSeries[index]).toLocaleString(undefined, {minimumFractionDigits: 2}) +'</b>'
                })

                if(this.instalmentSeries.length === 0){
                    this.instalmentSeries.push(100)
                    this.instalmentOptions.labels.push('No Installment')
                }
            }
        },
    }
</script>